var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _mask, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _mask2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSea01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0234375,
    y: 0.865234,
    width: 350,
    height: 233,
    fill: "#D38D8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.276 61.4113L220.312 65.1682L220.312 65.1672L233.348 68.9242L205.008 167.261L191.972 163.504L191.972 163.505L178.936 159.748L207.276 61.4113ZM246.385 72.682L233.348 68.925L205.008 167.262L218.044 171.019L246.385 72.682ZM246.386 72.6809L259.42 76.4372L259.42 76.4367L272.456 80.1937L244.116 178.531L231.082 174.774L231.082 174.775L218.045 171.018L246.386 72.6809ZM285.493 83.9515L272.457 80.1945L244.117 178.531L257.153 182.288L285.493 83.9515ZM298.529 87.7093L285.493 83.9524L257.153 182.289L270.189 186.046L298.529 87.7093Z",
    fill: "#442B26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 211.449,
    y: 62.4238,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 211.449 62.4238)",
    fill: "#E7F1F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 224.484,
    y: 66.1836,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 224.484 66.1836)",
    fill: "#357280"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 237.52,
    y: 69.9395,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 237.52 69.9395)",
    fill: "#E7F1F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250.557,
    y: 73.6953,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 250.557 73.6953)",
    fill: "#357280"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 276.629,
    y: 81.209,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 276.629 81.209)",
    fill: "#357280"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 263.594,
    y: 77.4531,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 263.594 77.4531)",
    fill: "#E7F1F3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 289.666,
    y: 84.9648,
    width: 13.5668,
    height: 102.339,
    transform: "rotate(16.0767 289.666 84.9648)",
    fill: "#E7F1F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.088 109.587C264.106 112.871 263.278 118.646 266.177 122.917L280.987 144.739L280.988 144.739C283.152 148.435 288.192 149.509 292.303 147.102C296.414 144.695 298.001 139.742 295.837 136.045L295.838 136.045L283.225 111.154C280.649 106.072 274.027 104.688 269.633 108.313L268.088 109.587Z",
    fill: "#0D1F23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.415 108.698C265.539 111.989 264.751 117.666 267.583 121.889L282.365 143.933L282.366 143.933C284.53 147.629 289.294 148.863 293.06 146.659C296.826 144.454 298.133 139.665 295.969 135.969L295.97 135.968L282.82 110.345C280.441 105.707 274.36 104.498 270.387 107.872L269.415 108.698Z",
    fill: "#DFE9EB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_569_27171",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.415 108.698C265.539 111.989 264.751 117.666 267.583 121.889L282.365 143.933L282.366 143.933C284.53 147.629 289.294 148.863 293.06 146.659C296.826 144.454 298.133 139.665 295.969 135.969L295.97 135.968L282.82 110.345C280.441 105.707 274.36 104.498 270.387 107.872L269.415 108.698Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.583 121.889L268.413 121.332L267.583 121.889ZM269.415 108.698L270.062 109.46L270.062 109.46L269.415 108.698ZM282.365 143.933L281.534 144.49L282.058 145.272L282.87 144.796L282.365 143.933ZM282.366 143.933L283.229 143.427L282.724 142.564L281.861 143.07L282.366 143.933ZM295.969 135.969L295.464 135.106L294.601 135.611L295.106 136.474L295.969 135.969ZM295.97 135.968L296.475 136.831L297.291 136.354L296.859 135.512L295.97 135.968ZM282.82 110.345L281.931 110.801L281.931 110.801L282.82 110.345ZM270.387 107.872L269.74 107.11L269.74 107.11L270.387 107.872ZM268.413 121.332C265.864 117.531 266.574 112.422 270.062 109.46L268.768 107.935C264.504 111.556 263.637 117.8 266.752 122.446L268.413 121.332ZM283.195 143.376L268.413 121.332L266.752 122.446L281.534 144.49L283.195 143.376ZM281.861 143.07L281.859 143.07L282.87 144.796L282.871 144.796L281.861 143.07ZM281.503 144.438C283.951 148.619 289.331 150.001 293.565 147.522L292.555 145.796C289.257 147.726 285.11 146.639 283.229 143.427L281.503 144.438ZM293.565 147.522C297.792 145.047 299.284 139.653 296.832 135.464L295.106 136.474C296.981 139.678 295.861 143.86 292.555 145.796L293.565 147.522ZM295.464 135.105L295.464 135.106L296.474 136.832L296.475 136.831L295.464 135.105ZM281.931 110.801L295.08 136.425L296.859 135.512L283.71 109.888L281.931 110.801ZM271.034 108.634C274.516 105.677 279.845 106.737 281.931 110.801L283.71 109.888C281.036 104.677 274.204 103.319 269.74 107.11L271.034 108.634ZM270.062 109.46L271.034 108.634L269.74 107.11L268.768 107.935L270.062 109.46Z",
    fill: "#228093",
    mask: "url(#path-12-inside-1_569_27171)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.836 113.924L274.154 115.129L272.086 130.355V130.355C271.069 128.617 270.696 126.576 271.032 124.591L272.836 113.924Z",
    fill: "#6A7173"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.059 113.207L274.464 114.946L288.754 120.595V120.595C287.736 118.858 286.139 117.533 284.243 116.854L274.059 113.207Z",
    fill: "#6A7173"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.096 112.656L273.199 114.54L272.056 131.216L271.681 130.576C270.53 128.612 270.084 126.315 270.416 124.063L272.096 112.656Z",
    fill: "#40C0DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.096 112.656L273.199 114.54L272.056 131.216L271.681 130.576C270.53 128.612 270.084 126.315 270.416 124.063L272.096 112.656Z",
    fill: "url(#paint0_linear_569_27171)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M273.201 114.543L272.098 112.659L272.026 113.146C272.059 113.187 272.798 114.458 273.164 115.089L273.201 114.543Z",
    fill: "#0D1F23"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.589 140.022C280.788 140.227 281.135 140.089 281.138 139.804V139.804C281.139 139.731 281.115 139.66 281.07 139.603L272.248 128.391L272.05 131.206L280.589 140.022Z",
    fill: "#20606D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.052 131.207L272.25 128.392L272.864 129.172L272.875 132.057L272.052 131.207Z",
    fill: "#0D1F23"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M293.074 132.716C293.155 132.989 292.865 133.224 292.614 133.087V133.087C292.55 133.052 292.5 132.997 292.472 132.929L287.014 119.749L289.566 120.954L293.074 132.716Z",
    fill: "#20606D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M273.367 111.916L274.47 113.8L289.571 120.966L289.196 120.325C288.047 118.361 286.262 116.847 284.136 116.034L273.367 111.916Z",
    fill: "#40C0DA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M273.367 111.916L274.47 113.8L289.571 120.966L289.196 120.325C288.047 118.361 286.262 116.847 284.136 116.034L273.367 111.916Z",
    fill: "url(#paint1_linear_569_27171)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M274.468 113.8L273.365 111.915L273.825 112.091C273.845 112.14 274.592 113.407 274.962 114.034L274.468 113.8Z",
    fill: "#0D1F23"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M289.566 120.953L287.014 119.748L287.394 120.665L289.904 122.087L289.566 120.953Z",
    fill: "#0D1F23"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 271.539,
    y: 111.697,
    width: 1.46519,
    height: 4.39557,
    rx: 0.732594,
    transform: "rotate(-30.3463 271.539 111.697)",
    fill: "#66BACB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.291 143.743L283.492 140.67L284.647 139.994C285.351 139.581 285.978 139.79 286.326 140.379C286.668 140.968 286.538 141.617 285.829 142.032L285.234 142.38L285.843 143.42L285.291 143.743ZM284.968 141.926L285.486 141.623C285.901 141.377 285.951 141.034 285.761 140.71C285.568 140.381 285.249 140.263 284.833 140.506L284.315 140.81L284.968 141.926Z",
    fill: "#C6D6DA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M288.16 142.11C287.977 142.216 287.739 142.156 287.635 141.972C287.528 141.795 287.593 141.561 287.774 141.452C287.952 141.351 288.188 141.409 288.293 141.587C288.399 141.77 288.336 142.007 288.16 142.11Z",
    fill: "#C6D6DA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.014 141.564L287.215 138.491L288.369 137.815C289.074 137.402 289.701 137.611 290.048 138.2C290.39 138.789 290.26 139.438 289.551 139.853L288.957 140.201L289.566 141.241L289.014 141.564ZM288.691 139.747L289.209 139.443C289.624 139.198 289.674 138.855 289.484 138.53C289.291 138.201 288.971 138.083 288.555 138.327L288.038 138.63L288.691 139.747Z",
    fill: "#C6D6DA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M290.415 136.617L292.215 139.69L291.671 140.008L289.872 136.935L290.415 136.617Z",
    fill: "#C6D6DA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M293.783 138.835C293.089 139.241 292.391 139.028 291.969 138.306C291.551 137.593 291.701 136.856 292.359 136.471C292.924 136.14 293.619 136.209 294.093 137.017L294.192 137.187L292.583 138.129C292.822 138.517 293.19 138.615 293.539 138.408C293.778 138.271 293.877 138.076 293.866 137.897L294.397 137.586C294.533 138.042 294.318 138.521 293.783 138.835ZM292.369 137.759L293.458 137.121C293.272 136.808 292.926 136.703 292.614 136.886C292.289 137.076 292.217 137.454 292.369 137.759Z",
    fill: "#C6D6DA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.891 94.9922C286.32 91.1347 292.122 90.5212 296.283 93.576L317.54 109.184L317.54 109.184C321.154 111.483 322.04 116.559 319.482 120.579C316.925 124.598 311.917 126 308.303 123.701L308.302 123.704L283.896 110.176C278.913 107.415 277.776 100.746 281.561 96.4884L282.891 94.9922Z",
    fill: "#0D1F23"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.603 94.8231C286.036 91.0716 291.738 90.494 295.854 93.4808L317.335 109.07L317.334 109.071C320.947 111.371 322.004 116.177 319.661 119.858C317.319 123.54 312.486 124.668 308.872 122.369L308.871 122.37L283.753 108.28C279.206 105.73 278.223 99.6091 281.742 95.7638L282.603 94.8231Z",
    fill: "#DFE9EB"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-2_569_27171",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.603 94.8231C286.036 91.0716 291.738 90.494 295.854 93.4808L317.335 109.07L317.334 109.071C320.947 111.371 322.004 116.177 319.661 119.858C317.319 123.54 312.486 124.668 308.872 122.369L308.871 122.37L283.753 108.28C279.206 105.73 278.223 99.6091 281.742 95.7638L282.603 94.8231Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M295.854 93.4808L295.266 94.2901L295.854 93.4808ZM282.603 94.8231L283.341 95.4982L283.341 95.4982L282.603 94.8231ZM317.335 109.07L317.922 108.26L318.684 108.813L318.179 109.606L317.335 109.07ZM317.334 109.071L316.797 109.914L315.954 109.377L316.491 108.534L317.334 109.071ZM308.872 122.369L308.028 121.832L308.565 120.989L309.409 121.525L308.872 122.369ZM308.871 122.37L309.715 122.907L309.207 123.705L308.382 123.242L308.871 122.37ZM283.753 108.28L284.242 107.408L283.753 108.28ZM281.742 95.7638L281.005 95.0887L281.005 95.0887L281.742 95.7638ZM295.266 94.2901C291.562 91.602 286.431 92.1219 283.341 95.4982L281.866 94.148C285.642 90.0214 291.914 89.386 296.441 92.6714L295.266 94.2901ZM316.748 109.879L295.266 94.2901L296.441 92.6714L317.922 108.26L316.748 109.879ZM316.491 108.534L316.491 108.533L318.179 109.606L318.178 109.607L316.491 108.534ZM317.871 108.227C321.958 110.829 323.139 116.255 320.505 120.395L318.818 119.321C320.869 116.098 319.937 111.913 316.797 109.914L317.871 108.227ZM320.505 120.395C317.876 124.526 312.431 125.818 308.335 123.213L309.409 121.525C312.54 123.518 316.761 122.553 318.818 119.321L320.505 120.395ZM308.028 121.833L308.028 121.832L309.715 122.906L309.715 122.907L308.028 121.833ZM284.242 107.408L309.361 121.498L308.382 123.242L283.263 109.152L284.242 107.408ZM282.48 96.4389C279.396 99.8089 280.258 105.173 284.242 107.408L283.263 109.152C278.155 106.287 277.051 99.4094 281.005 95.0887L282.48 96.4389ZM283.341 95.4982L282.48 96.4389L281.005 95.0887L281.866 94.148L283.341 95.4982Z",
    fill: "#228093",
    mask: "url(#path-28-inside-2_569_27171)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M287.702 98.4345L288.856 99.7963L304.149 98.2938V98.2938C302.45 97.2131 300.424 96.7646 298.428 97.0267L287.702 98.4345Z",
    fill: "#6A7173"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M286.939 99.6299L288.662 100.099L293.778 114.589V114.589C292.079 113.507 290.815 111.862 290.207 109.943L286.939 99.6299Z",
    fill: "#6A7173"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M286.462 97.6487L288.304 98.8208L305.011 98.2962L304.385 97.8976C302.465 96.6751 300.186 96.144 297.923 96.392L286.462 97.6487Z",
    fill: "#40C0DA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M286.462 97.6487L288.304 98.8208L305.011 98.2962L304.385 97.8976C302.465 96.6751 300.186 96.144 297.923 96.392L286.462 97.6487Z",
    fill: "url(#paint2_linear_569_27171)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M288.305 98.8208L286.463 97.6487L286.953 97.595C286.993 97.6291 288.236 98.415 288.852 98.8036L288.305 98.8208Z",
    fill: "#0D1F23"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M313.494 107.152C313.691 107.358 313.54 107.7 313.255 107.692V107.692C313.182 107.69 313.112 107.664 313.056 107.616L302.179 98.385L304.999 98.2915L313.494 107.152Z",
    fill: "#20606D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M305.001 98.291L302.181 98.3846L302.937 99.0268L305.82 99.1453L305.001 98.291Z",
    fill: "#0D1F23"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M305.731 119.354C306.001 119.446 306.247 119.164 306.119 118.909V118.909C306.087 118.844 306.033 118.792 305.967 118.761L292.997 112.818L294.107 115.413L305.731 119.354Z",
    fill: "#20606D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M285.675 98.8903L287.517 100.062L294.118 115.419L293.492 115.021C291.571 113.799 290.124 111.96 289.391 109.805L285.675 98.8903Z",
    fill: "#40C0DA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M285.675 98.8903L287.517 100.062L294.118 115.419L293.492 115.021C291.571 113.799 290.124 111.96 289.391 109.805L285.675 98.8903Z",
    fill: "url(#paint3_linear_569_27171)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M287.515 100.062L285.673 98.8904L285.832 99.3567C285.88 99.3782 287.118 100.171 287.731 100.565L287.515 100.062Z",
    fill: "#0D1F23"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M294.104 115.412L292.995 112.818L293.897 113.231L295.225 115.792L294.104 115.412Z",
    fill: "#0D1F23"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.46519,
    height: 4.39557,
    rx: 0.732594,
    transform: "matrix(-0.536859 0.843672 0.843672 0.536859 285.523 97.0566)",
    fill: "#66BACB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27171",
    x1: 272.096,
    y1: 112.656,
    x2: 274.162,
    y2: 129.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41B0C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27171",
    x1: 277.428,
    y1: 109.538,
    x2: 285.51,
    y2: 123.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BFD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_27171",
    x1: 286.462,
    y1: 97.649,
    x2: 303.281,
    y2: 100.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41B0C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_569_27171",
    x1: 283.148,
    y1: 102.861,
    x2: 296.644,
    y2: 111.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BFD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea01);
export default __webpack_public_path__ + "static/media/sea_01.7f36e65dd747ad04fd4b02600d22654c.svg";
export { ForwardRef as ReactComponent };